<ng-container *adaptLoadingUntilFirstEmit="let dataSource of recentMeetingsDataSource$">
    <dx-list [dataSource]="dataSource"
             [searchEnabled]="true"
             [searchExpr]="$any(['name', 'team.name'])"
             [grouped]="true"
             [collapsibleGroups]="true"
             displayExpr="name"
             selectionMode="single"
             height="100%"
             (onInitialized)="onListInitialized($event)"
             (onSelectionChanged)="onSelectionChanged($event)">
        <div *dxTemplate="let meeting of 'item'"
             class="d-flex">
            <span>{{ meeting.name }}</span>
            <small class="ms-auto text-muted text-nowrap">{{ meeting.meetingDateTime | adaptDate }}</small>
        </div>
        <div *dxTemplate="let group of 'group'">
            <i class="fal fa-users"></i>
            {{ group.key.substring(6) }}
        </div>
    </dx-list>
</ng-container>
